import axios from "@/libs/api.request";
// 获取列表
export const getCodRate = params => {
  return axios.request({
    url: "/finance/CodCurrency",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/CodCurrency",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/finance/CodCurrency/${id}`,
    method: "GET"
  });
};

// 获取货币列表
export const getCurrency = id => {
  return axios.request({
    url: `/finance/CodCurrency/select`,
    method: "GET"
  });
};

// 获取方案汇率详情
export const getRateDetails = params => {
  return axios.request({
    url: `/finance/CodCurrency/currency/${params.id}`,
    method: "get",
    params
  });
};

// 保存方案汇率详情
export const subRate = data => {
  return axios.request({
    url: `/finance/CodCurrency/currency/${data.id}`,
    method: "post",
    data
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/CodCurrency/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/CodCurrency/${id}`,
    method: "DELETE"
  });
};
